import React from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import PhoneSimulator from "../components/PhoneSimulator";
import { Button } from "../components/ui/button";
import { Sparkles, ArrowRight, CheckCircle2 } from "lucide-react";

const PainterSignup = () => {
  const quickReplies = [
    "Sipho Dlamini", "Sipho Painters", "082 555 1234",
    "Durbanville, Bellville, Brackenfell", "8",
    "English, isiZulu, Afrikaans",
    "Neat, friendly, on-time. Specialised in interior repaints.",
    "2", "FNB / Sipho Dlamini / 62812345678",
  ];

  return (
    <div className="bg-white">
      <section className="py-12 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 bg-[#25D366]/10 text-[#16A34A] px-3 py-1.5 rounded-full text-xs font-medium font-heading">
              <Sparkles className="w-3 h-3" /> For painters & tradespeople
            </div>
            <h1 className="font-heading mt-5 text-4xl sm:text-5xl font-bold text-[#2D3748] leading-tight tracking-tight">
              Get more work.<br/>
              <span className="text-[#25D366]">Free during MVP.</span>
            </h1>
            <p className="mt-5 text-lg text-[#718096] leading-relaxed">
              Try the painter onboarding right here in your browser. When you're ready, message Wazi on WhatsApp to set up your real profile.
            </p>
            <ul className="mt-7 space-y-3">
              {["Receive nearby leads via WhatsApp", "AI drafts professional quotes for you", "Build a public profile customers trust", "Collect reviews automatically after every job"].map((t) => (
                <li key={t} className="flex items-start gap-3 text-[#2D3748]">
                  <CheckCircle2 className="w-5 h-5 text-[#25D366] flex-shrink-0 mt-0.5" />
                  <span className="font-sans">{t}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 p-5 bg-[#F7FAFC] border border-[#E2E8F0] rounded-xl">
              <div className="text-sm text-[#718096] mb-2 font-heading font-semibold">When ready, message us on WhatsApp:</div>
              <a
                href="https://wa.me/27600702722?text=Hi%20Wazi%2C%20I%27m%20a%20painter%20and%20want%20to%20get%20started."
                target="_blank"
                rel="noopener noreferrer"
                data-testid="whatsapp-direct-link"
                className="inline-flex items-center gap-2 text-[#25D366] font-medium hover:underline"
              >
                +27 60 070 2722 — chat now
                <ArrowRight className="w-4 h-4" />
              </a>
              <div className="mt-2 text-xs text-[#718096]">Tap to open WhatsApp on your phone. Wazi will guide you through onboarding in under 3 minutes.</div>
            </div>
            <Link to="/">
              <Button variant="outline" className="mt-6 rounded-full" data-testid="back-home-btn">← Back to home</Button>
            </Link>
          </div>
          <div>
            <PhoneSimulator role="painter" sessionPrefix="signup-painter" quickReplies={quickReplies} />
            <p className="mt-4 text-center text-sm text-[#718096]">Live demo — chat with Wazi as if you were on WhatsApp.</p>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default PainterSignup;
